<div class="lv-flex" *ngIf="uiArtefakt.ListenelementComponent === 'Aufzaehlung'">
  <span class="lv-bullet-point">&bull;</span>
  <div>
    <lv-uiartefakt-container [uiArtefakte]="uiArtefakt.UIArtefakt"></lv-uiartefakt-container>
  </div>
</div>
<lv-uiartefakt-container [uiArtefakte]="uiArtefakt.UIArtefakt"
                         *ngIf="uiArtefakt.ListenelementComponent === 'Normal'"></lv-uiartefakt-container>

